import type { Handler } from './handler';
import type { ApiFetchRouletteDetailPort } from './ports/api-fetch-roulette-detail.port';
import type { RouletteDetail } from '~/types/roulette';
import { resolveAdapter } from '~/adapters/registry';

export const fetchRouletteDetailHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchRouletteDetail: resolveAdapter('apiFetchRouletteDetail'),
  },
) => {
  return await ports.apiFetchRouletteDetail.handle(params.slug, params.userId);
};

type Params = { slug: string; userId: number };

type Ports = { apiFetchRouletteDetail: ApiFetchRouletteDetailPort };

type Result = Promise<RouletteDetail>;
